import EntityTypeEnum from 'common/enums/entityTypeEnum'
import EntityInterface from 'common/types/entities/EntityInterface'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import React from 'react'
import { BaseEntityInterface } from 'src/shared/types/base-entity-interface'
import createCommonEntityElement, {
  AdditionalProps,
} from 'client/pages/createCommonEntityElement'
import { WebsiteLogin } from 'src/editor/shared/entities/website-login'
import { WebsiteLoginInterface } from 'src/shared/types/entities/website-login-interface'

export const createEntityElementForWebsiteLogin = (
  entity: EntityInterface | OldEntityInterface | BaseEntityInterface,
  additionalProps: AdditionalProps,
) => {
  switch (entity.type) {
    case EntityTypeEnum.WebsiteLogin:
      return (
        <WebsiteLogin
          entity={entity as WebsiteLoginInterface}
          {...additionalProps}
        />
      )
    default:
      return createCommonEntityElement(
        entity as EntityInterface | OldEntityInterface,
        additionalProps,
      )
  }
}
